"use client";

import { usePathname } from "next/navigation";

/**
 * /admin and /auth render without the public site chrome (header, footer,
 * announcement bar, radio player, cookie consent) — those are for the public
 * front end only and overlap the admin workspace (the fixed player bar).
 */
const CHROMELESS_PREFIXES = ["/admin", "/auth"];

export function isChromelessPath(pathname: string): boolean {
  return CHROMELESS_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function ChromeGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (isChromelessPath(pathname)) {
    return null;
  }
  return <>{children}</>;
}

/**
 * <main> wrapper that drops the public player's bottom padding on
 * chromeless (admin/auth) routes.
 */
export function MainShell({
  isSunny,
  dataMotion,
  children,
}: {
  isSunny: boolean;
  dataMotion?: string;
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const chromeless = isChromelessPath(pathname);
  const className = chromeless
    ? "flex-1"
    : isSunny
      ? "flex-1 pb-44 sm:pb-48 lg:pb-28"
      : "flex-1";
  return (
    <main id="main-content" className={className} data-motion={dataMotion} tabIndex={-1}>
      {children}
    </main>
  );
}
